import { render, staticRenderFns } from "./A7DashletVisaoEvolucao.vue?vue&type=template&id=67ec365a&scoped=true&"
import script from "./A7DashletVisaoEvolucao.vue?vue&type=script&lang=js&"
export * from "./A7DashletVisaoEvolucao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ec365a",
  null
  
)

export default component.exports